import { tv } from 'tailwind-variants';

export default tv({
    slots: {
        root: 'relative flex items-start',
        base: 'data-[state=unchecked]:bg-neutrals-400 inline-flex shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-[background] duration-200 focus-visible:outline-2 focus-visible:outline-offset-2',
        container: 'flex items-center',
        thumb: 'group pointer-events-none flex items-center justify-center rounded-full bg-white shadow-lg ring-0 transition-transform duration-200 data-[state=checked]:translate-x-full data-[state=unchecked]:translate-x-0',
        wrapper: 'ms-2',
        label: 'text-primary block font-medium',
        description: 'text-muted',
    },
    variants: {
        color: {
            primary: {
                base: 'data-[state=checked]:bg-primary focus-visible:outline-primary',
            },
            accent: {
                base: 'data-[state=checked]:bg-accent focus-visible:outline-accent',
            },
        },
        size: {
            sm: {
                base: 'w-9',
                container: 'h-5',
                thumb: 'size-4 data-[state=checked]:translate-x-4',
                wrapper: 'text-sm',
            },
            md: {
                base: 'w-10',
                container: 'h-5',
                thumb: 'size-4.5 data-[state=checked]:translate-x-4.5',
                wrapper: 'text-sm',
            },
            lg: {
                base: 'w-11',
                container: 'h-6',
                thumb: 'size-5 data-[state=checked]:translate-x-5',
                wrapper: 'text-base',
            },
        },
        disabled: {
            true: {
                base: 'cursor-not-allowed opacity-75',
                label: 'cursor-not-allowed opacity-75',
                description: 'cursor-not-allowed opacity-75',
            },
        },
    },
    defaultVariants: {
        color: 'accent',
        size: 'lg',
    },
});
